import { observer } from "mobx-react";
import FontBody2 from "../../../../../components/fonts/font-body2/font-body2";
import { FONT_COLOR, FONT_VARIANT } from "../../../../../components/fonts/font-props";
import IconCheck from "../../../../../components/icons/icon-check/icon-check";
import IconExclamation from "../../../../../components/icons/icon-exclamation/icon-exclamation";
import IconDiscard from "../../../../../components/icons/icon-discard/icon-discard";
import IconProcessing from "../../../../../components/icons/icon-processing/icon-processing";
import { IconProps } from "../../../../../components/icons/icon-props-interface";
import Icon from "../../../../../components/icons/icon/icon";
import { Button } from "../../../../../components/inputs/button/button";
import { BUTTON_VARIANTS } from "../../../../../components/inputs/button-variants";
import { ButtonIcon } from "../../../../../components/inputs/button-icon/button-icon";
import {
    BACKGROUND_JOB_NOTICE_STATE,
    BackgroundJobNoticeStore,
} from "../../stores/background-job-notice-store";
import "./background-job-notice.scss";

interface IProps {
    notice: BackgroundJobNoticeStore;
}

const BackgroundJobNotice: React.FC<IProps> = observer(({ notice }) => {
    const iconComponent = (): React.FC<IconProps> => {
        switch (notice.state) {
            case BACKGROUND_JOB_NOTICE_STATE.IN_PROGRESS:
                return IconProcessing;
            case BACKGROUND_JOB_NOTICE_STATE.COMPLETE:
            case BACKGROUND_JOB_NOTICE_STATE.PARTIAL:
                return () => <IconCheck color="var(--color-semantic-success)" />;
            case BACKGROUND_JOB_NOTICE_STATE.STOPPED:
                return () => <IconExclamation color="var(--color-accent-3)" />;
            default:
                throw new Error(`[BackgroundJobNotice] Unknown state: ${notice.state}`);
        }
    };

    const showActions = notice.actionButton || notice.onClose;

    return (
        <div className="background-job-notice">
            <div className="background-job-notice__main">
                <div className="background-job-notice__icon">
                    <Icon Component={iconComponent()} />
                </div>
                <div className="background-job-notice__text">
                    <FontBody2 variant={FONT_VARIANT.BOLD} color={FONT_COLOR.PRIMARY2}>
                        {notice.title}
                    </FontBody2>
                    <div className="background-job-notice__description">{notice.description}</div>
                </div>
            </div>
            {showActions && (
                <div className="background-job-notice__actions">
                    {notice.actionButton && (
                        <Button
                            variant={BUTTON_VARIANTS.Secondary}
                            text={notice.actionButton.title}
                            onClick={notice.actionButton.onClick}
                        />
                    )}
                    {notice.onClose && (
                        <ButtonIcon
                            Component={IconDiscard}
                            color="var(--color-neutral-3)"
                            onClick={() => notice.close()}
                        />
                    )}
                </div>
            )}
        </div>
    );
});

export default BackgroundJobNotice;
